import { render, staticRenderFns } from "./CompletionBuy.vue?vue&type=template&id=40a17c1a&scoped=true"
import script from "./CompletionBuy.vue?vue&type=script&lang=ts"
export * from "./CompletionBuy.vue?vue&type=script&lang=ts"
import style0 from "./CompletionBuy.vue?vue&type=style&index=0&id=40a17c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a17c1a",
  null
  
)

export default component.exports